import { render, staticRenderFns } from "./centerAddress.vue?vue&type=template&id=4b2250de&"
import script from "./centerAddress.vue?vue&type=script&lang=js&"
export * from "./centerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports